/* unplugin-vue-components disabled */import script from "./RoleSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./RoleSelector.vue?vue&type=script&setup=true&lang=js"

import "./RoleSelector.vue?vue&type=style&index=0&id=400e17d8&scoped=true&lang=less"

import exportComponent from "/Users/zhangxuan/Documents/Projects/VinesDjango/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-400e17d8"]])

export default __exports__